<template>
  <div class="rightconover">
    <div class="contentwidth">
      <div class="ContentMargin">
        <div>
          <div class="content_head">
            <div class="content_head_ico">
              <img src="@/assets/images/estorage/content_title_ico_blue.png" alt="" />
            </div>
            <div class="content_head_title">
              质检项
            </div>
            <div class="content_head_button">
              <div class="content_head_seek">
                <el-input placeholder="输入质检项名称" v-model="queryCheckNumber" class="input-with-select">
                  <el-button slot="append" icon="el-icon-search" @click="getQCList(1)"></el-button>
                </el-input>
              </div>
            </div>
          </div>
          <div class="Notice_list">
            <el-table :data="QCList" style="width: 100%">
              <el-table-column prop="checkNumber" label="质检项编码" align="center"/>
              <el-table-column prop="checkName" label="质检项名称" align="center" width="300"/>
              <el-table-column prop="chname" label="添加人" align="center"/>
              <el-table-column prop="createDate" label="添加时间" align="center"/>
              <el-table-column prop="checkDescribe" label="描述" align="center" width="400"/>
            </el-table>
          </div>
          <!--          分页器-->
          <div class="paging">
            <div class="block">
              <el-pagination background @current-change="handleCurrentChange" :current-page="currentPage"
                layout="total, prev, pager, next, jumper" :total="totalQuantity">
              </el-pagination>
            </div>
          </div>
          <!--        新增，详细，编辑弹窗-->
          <el-dialog :title="dialogTitle" :visible.sync="redactShow" width="30%" style="margin-top: 20vh">
            <div class="dialog_content" v-if="dialogTitle === '详情' || dialogTitle === '删除'">
              <p>质检项编码: {{ checkNumber }}</p>
              <p>质检项名称: {{ checkName }}</p>
              <p>描述: {{ checkDescribe }}</p>
            </div>
            <div class="dialog_content" v-if="dialogTitle === '编辑' || dialogTitle === '新增'">
              <div>
                <span><span style="color:red;padding-right:0;width:auto;">*</span>质检项编码:</span>
                <el-input v-model="checkNumber" placeholder="质检项编码" :disabled="dialogTitle === '编辑'"></el-input>
              </div>
              <div>
                <span><span style="color:red;padding-right:0;width:auto;">*</span>质检项名称:</span>
                <el-input v-model="checkName" placeholder="质检项名称" :disabled="dialogTitle === '编辑'"></el-input>
              </div>
              <div>
                <span>描述:</span>
                <el-input v-model="checkDescribe" type="textarea" placeholder="描述"></el-input>
              </div>
            </div>
            <span slot="footer" class="dialog-footer">
              <el-button @click="redactShow = false">取消</el-button>
              <el-button type="primary" @click="addQCDate" v-if="dialogTitle === '新增'">保存</el-button>
              <el-button type="primary" @click="upQCDate" v-if="dialogTitle === '编辑'">保存</el-button>
              <el-button type="danger" @click="QCDelete" v-if="dialogTitle === '删除'">删除</el-button>
            </span>
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { httpToken } from '@/utils/http'

import qs from 'qs'

export default {
  name: 'Items',
  data() {
    return {
      QCList: [],
      ids: '',
      checkNumber: '',
      checkName: '',
      checkDescribe: '',
      currentPage: 1,
      totalQuantity: 10,
      queryCheckNumber: '',
      redactShow: false,
      dialogTitle: '',
    }
  },
  methods: {
    //上传新增或更改质检项数据
    addQCDate() {
      if (this.checkNumber === '') {
        this.$message({
          message: '请填写质检项编号',
          type: 'error'
        })
      } else if (this.checkName === '') {
        this.$message({
          message: '请填写质检项名称',
          type: 'error'
        })
      } else {
        httpToken({
          url: '/item/save',
          method: 'post',
          data: {
            checkNumber: this.checkNumber,
            checkName: this.checkName,
            chname: JSON.parse(sessionStorage.getItem('user')).chnname,
            checkDescribe: this.checkDescribe
          }
        }).then(res => {
          this.redactShow = false
          if (res.data.code === 200) {
            this.$message({
              message: res.data.msg,
              type: 'success'
            })
            this.getQCList(this.currentPage)
          } else {
            this.$message({
              message: res.data.msg,
              type: 'error'
            })
          }
        })
      }
    },
    // 编辑上传
    upQCDate() {
      if (this.checkNumber === '') {
        this.$message({
          message: '请填写质检项编号',
          type: 'error'
        })
      } else if (this.checkName === '') {
        this.$message({
          message: '请填写质检项名称',
          type: 'error'
        })
      } else {
        httpToken({
          url: '/item/update',
          method: 'post',
          data: {
            id: this.ids,
            checkNumber: this.checkNumber,
            checkName: this.checkName,
            checkDescribe: this.checkDescribe
          }
        }).then(res => {
          this.redactShow = false
          if (res.data.code === 200) {
            this.$message({
              message: res.data.msg,
              type: 'success'
            })
            this.getQCList(this.currentPage, 1)
          } else {
            this.$message({
              message: res.data.msg,
              type: 'error'
            })
          }
        })
      }
    },
    // 获取质检项数据
    getQCList(page, max) {
      let paramData = [{ column: "id", type: '', value: '' }, { column: "create_date", type: "orderByDesc" }]
      if (this.queryCheckNumber) {
        paramData.push({ column: "check_name", type: 'like', value: this.queryCheckNumber })
      }
      httpToken({
        url: '/item/list',
        method: 'post',
        data: qs.stringify({
          paramData: JSON.stringify(paramData),
          page: page,
          rows: 10
        })
      }).then(res => {
        if (max === 1) {
          if (res.data.data.currentPage !== page || res.data.data.currentPage !== res.data.data.pages) {
            this.getQCList(res.data.data.pages)
            return;
          }
        } else if (max === 2) {
          if (res.data.data.currentPage !== page) {
            this.getQCList(res.data.data.pages)
            return;
          }
        }
        const QC = res.data.data.records
        this.QCList = []
        QC.forEach((item) => {
          item.createDate = item.createDate.replace('T', ' ')
        })
        this.QCList = QC
        this.totalQuantity = res.data.data.total
        this.currentPage = page
      })
    },
    // 详情和编辑和新增按键
    QCDetails(val, state) {
      this.redactShow = true
      this.dialogTitle = val
      if (state) {
        this.ids = state.id
        this.checkNumber = state.checkNumber
        this.checkName = state.checkName
        this.checkDescribe = state.checkDescribe
      } else {
        this.ids = ''
        this.checkNumber = ''
        this.checkName = ''
        this.checkDescribe = ''
      }
    },
    // 删除质检项信息
    QCDelete() {
      httpToken({
        url: '/item/delete',
        method: 'post',
        data: qs.stringify({ ids: this.ids })
      }).then(res => {
        if (res.data.code === 200) {
          this.redactShow = false
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getQCList(this.currentPage, 2)
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error'
          })
        }
      })
    },
    // 切换页码
    handleCurrentChange(val) {
      this.getQCList(val)
    }
  }
  ,
  mounted() {
    this.getQCList(1)
  }
}
</script>

<style scoped lang="scss">
.rightconover {
  height: 100%;
  background-color: #f5f6fa;
  overflow: auto;

  .contentwidth {
    width: 100%;

    .ContentMargin {
      box-sizing: border-box;
      margin: 30px 35px;
      background-color: #ffffff;
      box-shadow: 0 3px 5px 0 #d5dade;
      padding: 30px 40px;
    }
  }
}

.content_head {
  display: flex;
  font-size: 18px;
  margin-bottom: 50px;

  .content_head_ico {
    height: 17px;
    width: 4px;
    margin: auto 10px auto 0;

    img {
      width: 100%;
      height: 100%;
      display: block;
    }
  }

  .content_head_title {
    margin: auto 0;
  }

  .content_head_button {
    max-width: 70%;
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap;
    margin-left: auto;

    ::v-deep .el-button {
      padding: 10px 42px;
      font-size: 16px;

      span {
        font-size: 14px;
      }
    }

    .content_head_seek {
      vertical-align: top;
      margin-left: 20px;

      ::v-deep .el-input-group__append {
        padding: 0 18px;
      }

      .el-button {
        padding: 10px;
      }
    }
  }
}

.Notice_list {
  ::v-deep .el-table th {
    background-color: #F5F8FF;
  }

  ::v-deep .el-table thead {
    color: #000000
  }
}

.dialog_content {
  //margin-bottom: 30px;

  p {
    margin-bottom: 10px;
  }

  div {
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    span {
      text-align: right;
      width: 30%;
      padding-right: 10px;
    }

    .el-input {
      width: 60%;
      margin: auto 0;
    }

    .el-textarea {
      width: 60%;
      margin: auto 0;
    }
  }
}

.paging {
  margin-top: 20px;

  ::v-deep .el-pagination {
    text-align: right;
  }
}
</style>
